import { adminUsersApiURL } from "API/urls/admin.api";
import { axiosInstance } from "configs/axios";

export const addUserApi = async (addUserApiParameter) => {
  try {
    const response = await axiosInstance.post(adminUsersApiURL.addUser, {
      ...addUserApiParameter,
    });
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response.data,
      status: error?.response?.request?.status,
    };
  }
};
